import { cn } from "@/lib/utils"
import { HTMLAttributes, useState } from "react"

interface ImageProps extends HTMLAttributes<HTMLImageElement> {
  src: string
  alt: string
  className?: string
}

export const Image = ({ src, alt, className, ...props }: ImageProps) => {
  const [error, setError] = useState(false)

  console.log('Loading image from:', src) // Debug log

  if (error) {
    console.error('Failed to load image:', src)
    return <div className={cn("bg-muted flex items-center justify-center", className)}>{alt}</div>
  }

  return (
    <img
      src={src}
      alt={alt}
      className={cn("object-contain", className)}
      onError={() => setError(true)}
      {...props}
    />
  )
}